import React, { memo, useState } from "react";
import { dcolors, dlog, TObject } from "corexxx";
import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import {
    DPageRootLayout,
    DPageRootLayoutWithDrawer,
} from "../../libs/dweb/DPageRootLayout";
import { useMoney } from "../models/Hook";
import { useEffect } from "react";

import { YearBudget } from "./YearBudgetPage";
import { NetWorthView } from "./NetWorthPage";
import { DNeedsLogin } from "../../libs/dweb/DNeedsLogin";
import { DResponsiveWindow } from "../../libs/dweb/DResponsiveWindow";
import { Button } from "@mui/material";
import { DButton } from "../../libs/dweb/DButton";
import { DCol } from "../../libs/dweb/DCol";
import { DBox } from "../../libs/dweb/DBox";
import { DRow } from "../../libs/dweb/DRow";
import { DDialogSimple } from "../../libs/dweb/DDialogSimple";
import { DText } from "../../libs/dweb/DText";
import { DLayoutTwoCol } from "../../libs/dweb/DLayoutTwoCol";
import { DHook } from "../../libs/common_hooks/DHook";
import { DTwoPaneView } from "../../libs/dweb/DTwoPaneView";
import { DTable } from "../../libs/dweb/DTable";
import { DIconButton } from "../../libs/dweb/DIconButton";
import { DAlert } from "../../libs/dweb/DAlert";
import { LineChart, CartesianGrid, XAxis, YAxis, Legend, Line, Tooltip, ResponsiveContainer, Text, Label, ReferenceLine } from "recharts";
import { DRefreshButton } from "../../libs/dweb/DRefreshButton";
import { getLastTradingDay, convertToQuote, getFormattedDate, calculateNetDelta, mergeTradingData, generateTradingTimes } from "./helper";


export function TopSymbolSummary({ data }: { data: any }) {
    return <>
        <DText style={{ flex: 1 }} html>{` ${data.symbol} 
      <span style="font-weight:bold;font-size:large;color:${data.quote.netChange > 0 ? "green" : "red"}"> 
      ${data.quote.netChange > 0 ? '<span style="color:green">⬆</span>' : '<span style="color:red">⬇</span>'} 
      ${data.quote.lastPrice.toFixed(2)}(${data.quote.netChange > 0 ? '+' : ''}
      ${data.quote.netChange}, ${data.quote.netPercentChange.toFixed(2)}%)
      </span>
      <span style="font-size:12px">on ${getFormattedDate(data.quote.tradeTime)}</span>
          <span style="font-size:12px">P.Close ${(data.quote.lastPrice - data.quote.netChange).toFixed(2)}</span>
      
      `}</DText>
    </>
}


export function ChainSummary({ spxChain }: { spxChain: any }) {
    let appCommand = useDAppCommand()
    const [data, setData] = useState<string>(''); // Historical SPX price data
    let resp = spxChain;
    React.useEffect(() => {
        if (resp.state.data?.status != "success") {
            return;
        }
        let resp0 = resp.state.data.out as any
        let resp1 = calculateNetDelta(resp0) as any
        setData(`Net Delta: <span style="color:green;font-weight:bold">${resp1.netDelta}</span> ✫
         Total Call Vol: <span style="color:green;font-weight:bold">${resp1.totalCallVolume}</span> ✫
         Total put Vol: <span style="color:green;font-weight:bold">${resp1.totalPutVolume}</span> ✫
         Put/Call: <span style="color:green;font-weight:bold">${resp1.ratio}</span>
         `)
    }, [resp.state.data])
    return <DText html>{data}</DText>
}

export const BottomTable = memo(({ spxChain }: { spxChain: any }) => {
    let appCommand = useDAppCommand()
    const [data, setData] = useState<any>(null); // Historical SPX price data
    let resp = spxChain
    React.useEffect(() => {
        if (resp.state.data?.status != "success") {
            return;
        }
        let resp0 = resp.state.data.out as any
        setData(calculateNetDelta(resp0) as any)
    }, [resp.state.data])
    return data ? <DRow style={{ flex: 0 }}>
        <DTable
            config={{ title: 'Top 5 Call' }}
            data={data.topCalls}
            style={{ width: 'auto', marginRight: 10, flex: 1 }}
            columns={[
                { field: 'strikePrice' },
                { field: 'totalVolume' },
                { field: 'gamma' },
                { field: 'delta' }
            ]} />
        <DTable
            config={{ title: 'Top 5 Put' }}
            style={{ width: 'auto', marginRight: 10, flex: 1 }}
            data={data.topPuts}

            columns={[
                { field: 'strikePrice' },
                { field: 'totalVolume' },
                { field: 'gamma' },
                { field: 'delta' }
            ]} />
        <DTable
            config={{ title: 'highGammaCalls' }}
            style={{ width: 'auto', marginRight: 10, flex: 1 }}
            data={data.highGammaCalls}
            columns={[
                { field: 'strikePrice' },
                { field: 'totalVolume' },
                { field: 'gamma' },
                { field: 'delta' },
            ]} />
        <DTable
            config={{ title: 'highGammaPuts' }}
            data={data.highGammaPuts}
            style={{ width: 'auto', flex: 1 }}
            columns={[
                { field: 'strikePrice' },
                { field: 'totalVolume' },
                { field: 'gamma' },
                { field: 'delta' },
            ]} />

    </DRow> : null
})


export function SymbolChart({ symbol, cursorIndex, onMouseMove, data }: { symbol: string, cursorIndex?: any, onMouseMove: any, data: any }) {
    let appCommand = useDAppCommand()
    const [priceData, setPriceData] = useState<any[]>(data); // Historical SPX price data
    const [lastData, setLastData] = useState(6100);
    React.useEffect(() => {
        setPriceData(mergeTradingData(generateTradingTimes(), data || []))
        // setPriceData(data)
    }, [data])

    return (<DCol style={{ height: 200, flex: 0 }}>
        <ResponsiveContainer width="100%" height={200}>
            <LineChart data={priceData} onMouseMove={onMouseMove}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis domain={["auto", "auto"]} />
                <YAxis>
                    {/* Add a custom label to the Y-axis */}
                    <Label value="Price" angle={-90} position="left" style={{ fontSize: 16, fontWeight: "bold" }} />
                </YAxis>
                <Tooltip
                />
                <Legend
                    verticalAlign="top"
                    align="right"
                    iconType="circle"
                    iconSize={10}
                    formatter={(value) => (
                        <span style={{ color: "#8884d8", fontSize: 14 }}>
                            {symbol}: {value} - Stock Price (USD)
                        </span>
                    )}
                />
                <Line type="monotone" dataKey="price" stroke="#8884d8" activeDot={{ r: 8 }} dot={false} connectNulls={true} />
                {lastData > 0 ?
                    <ReferenceLine y={lastData} stroke="red" strokeDasharray="1 1" label="Previous Close" /> : null}
            </LineChart>
        </ResponsiveContainer>
    </DCol>)
}
